import $axios from "@/plugins/axios";
import { Decrypt } from "@/js/encryp.js";

const login = {
    //获取token
    //doLogin: params => $axios.post3(Decrypt("WlA2J4Z6h32f861hph2oVEbk7WmMSh7oN9SJGtIXegs="), params),
    //getMenuList: params => $axios.post3(Decrypt("RXm9E+SdefGaWVgpnUMWfY/kQQsGHRpXXDaYB8d9/s0="),params),
    //modifyPwd: params => $axios.post(Decrypt(`f29ghVt/1+GTTIfSjDRWA+eh0MQKmdSS2mlRMtFnSng=`), params),
    //获取IP接口
    //GetIP: params => $axios.get(Decrypt(`jokTTPet3Pb56nKVRGpfGw==`), params),
    //GetValue: params => $axios.get(Decrypt(`GZhirJHHYGIC/poE5WLW/A==`), params),
    //GetRefreshToken: params => $axios.post(Decrypt(`N+QWpk37AYYkDwURYGgzZWOsc9KvDBMByRu0yuKO5tM=`), params),

    doLogin: params => $axios.post3('Auth/GetUserToken', params),
    GetRefreshToken: params => $axios.post('Auth/RefreshToken', params),
    LoginByOrg: params => $axios.post3('Auth/GetUserTokenByOrg', params),
    getAgentIdByOrgId: params => $axios.post3('Auth/getAgentIdByOrgId', params),
    getSystemTitle: params => $axios.post3('Auth/getSystemTitle', params),
    getLogo: params => $axios.post3('Auth/getLogo', params),
};

export default login;
